import AbstractPolicy from '@/Services/Auth/Policies/AbstractPolicy';

export default class ImportPolicy extends AbstractPolicy{
    static viewAny(user, model = null) {
        return this._userHasPermission(user, 'import.viewAny');
    }

    static view(user, model = null) {
        return this._userHasPermission(user, 'import.view') ;
    }

    static create(user, model = null) {
        return this._userHasPermission(user, 'import.create');
    }

    static update(user, model = null) {
        return this._userHasPermission(user, 'import.update');
    }

    static delete(user, model = null) {
        return this._userHasPermission(user, 'import.delete');
    }

    static restore(user, model = null) {
        return this._userHasPermission(user, 'import.restore');
    }

    static forceDelete(user, model = null) {
        return this._userHasPermission(user, 'import.forceDelete');
    }
}
